import { takeEvery, throttle } from 'redux-saga/effects';
import { updateToolbarUserCountSaga } from 'features/toolbar/sagas/updateToolbarUserCountSaga';
import { onSipUsersJoinedForCountSaga } from 'features/toolbar/sagas/onSipUsersJoinedForCountSaga';
import { onSipUsersLeftForCountSaga } from 'features/toolbar/sagas/onSipUsersLeftForCountSaga';
import { onSipBridgeDisconnectedForCountSaga } from 'features/toolbar/sagas/onSipBridgeDisconnectedForCountSaga';
import { signalingUserJoined } from 'features/users/actions';
import {
  signalingPhoneBridgeDisconnected,
  signalingPhoneUsersJoined,
  signalingPhoneUsersLeft,
} from 'features/sip/actions';
import { roomJoined } from 'features/room/roomSlice';
import { userLeft } from 'features/users/usersSlice';

export default function* toolbarWatcher() {
  yield throttle(1000, signalingUserJoined, updateToolbarUserCountSaga);
  yield takeEvery(userLeft, updateToolbarUserCountSaga);

  yield takeEvery(signalingPhoneUsersJoined, onSipUsersJoinedForCountSaga);
  yield takeEvery(signalingPhoneUsersLeft, onSipUsersLeftForCountSaga);
  yield takeEvery(signalingPhoneBridgeDisconnected, onSipBridgeDisconnectedForCountSaga);

  yield takeEvery(roomJoined, updateToolbarUserCountSaga);
}
